import { Bell, HeadphonesIcon, Mail, Phone, MessageCircle } from "lucide-react";
import TutorMobileLayout from "../components/tutor/TutorMobileLayout";
import { SOCIAL } from "../data/siteData";

export function TutorNotifications() {
    return (
        <TutorMobileLayout title="Notifications" backTo="/tutor/dashboard">
            <div className="bg-white border border-dashed border-slate-300 rounded-2xl p-8 text-center" data-testid="tutor-notifications-empty">
                <Bell className="w-10 h-10 mx-auto text-slate-300 mb-2" />
                <div className="font-semibold text-slate-700">All caught up</div>
                <p className="text-xs text-slate-500 mt-1">
                    Push &amp; in-app notifications launch in Phase 6 — demo reminders, new-match alerts, and parent updates.
                </p>
            </div>
        </TutorMobileLayout>
    );
}

export function TutorSupport() {
    return (
        <TutorMobileLayout title="Support" backTo="/tutor/dashboard">
            <div className="bg-gradient-to-br from-blue-500 to-indigo-600 text-white rounded-2xl p-5 mb-4 shadow-md" data-testid="tutor-support-hero">
                <div className="text-[10px] uppercase tracking-[0.2em] opacity-80">Need help?</div>
                <h2 className="font-bold text-lg leading-tight mt-1">We're here for you</h2>
                <p className="text-xs opacity-90 mt-2">Reach our tutor success team via call, WhatsApp or email — typically replies within 1 business hour.</p>
            </div>
            <div className="space-y-3">
                <a href="tel:+917000530316" data-testid="tutor-support-call"
                    className="flex items-center gap-3 bg-white border border-slate-200 rounded-2xl p-4 hover:shadow active:scale-[0.98] transition">
                    <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center"><Phone className="w-5 h-5 text-emerald-700" /></div>
                    <div className="flex-1">
                        <div className="font-bold text-[#0F172A]">Call us</div>
                        <div className="text-xs text-slate-500">Available 9 AM – 9 PM</div>
                    </div>
                </a>
                <a href={`https://wa.me/${SOCIAL.whatsapp}`} target="_blank" rel="noreferrer" data-testid="tutor-support-whatsapp"
                    className="flex items-center gap-3 bg-white border border-slate-200 rounded-2xl p-4 hover:shadow active:scale-[0.98] transition">
                    <div className="w-10 h-10 rounded-xl bg-green-100 flex items-center justify-center"><MessageCircle className="w-5 h-5 text-green-700" /></div>
                    <div className="flex-1">
                        <div className="font-bold text-[#0F172A]">WhatsApp</div>
                        <div className="text-xs text-slate-500">Quick text · 24/7</div>
                    </div>
                </a>
                <a href="mailto:tutors@anandtutorials.com" data-testid="tutor-support-email"
                    className="flex items-center gap-3 bg-white border border-slate-200 rounded-2xl p-4 hover:shadow active:scale-[0.98] transition">
                    <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center"><Mail className="w-5 h-5 text-blue-700" /></div>
                    <div className="flex-1">
                        <div className="font-bold text-[#0F172A]">Email</div>
                        <div className="text-xs text-slate-500">tutors@anandtutorials.com</div>
                    </div>
                </a>
            </div>
        </TutorMobileLayout>
    );
}

// Stubs for soon pages
export function TutorEarnings() {
    return (
        <TutorMobileLayout title="Earnings" backTo="/tutor/dashboard">
            <div className="bg-white border border-dashed border-slate-300 rounded-2xl p-8 text-center" data-testid="tutor-earnings-soon">
                <HeadphonesIcon className="w-10 h-10 mx-auto text-slate-300 mb-2" />
                <div className="font-semibold text-slate-700">Coming soon</div>
                <p className="text-xs text-slate-500 mt-1">Monthly fee tracking, payment history and payout requests land in our billing phase.</p>
            </div>
        </TutorMobileLayout>
    );
}

export function TutorRefer() {
    return (
        <TutorMobileLayout title="Refer & Earn" backTo="/tutor/dashboard">
            <div className="bg-gradient-to-br from-pink-500 to-rose-600 text-white rounded-2xl p-5 mb-4 shadow-md">
                <div className="text-[10px] uppercase tracking-[0.2em] opacity-80">Coming soon</div>
                <h2 className="font-bold text-xl leading-tight mt-1">Refer a fellow tutor</h2>
                <p className="text-xs opacity-90 mt-2">Earn ₹500 every time a referred tutor completes their first tuition month with us.</p>
            </div>
        </TutorMobileLayout>
    );
}
